import React, { useState,useEffect } from 'react';
import "../sample/global.scss";
import { Divider } from '@fluentui/react-components';
import { labelValue } from '../Helpers';

    interface AanvragerBoxProps {
        title: string;
        project: {  
            requestorAccount: {
                name: string;
            }
            requestorContact: {
                name: string;
            }
            requestorAccountType: string;
            requestorSubType: string;
            requestorAccountSize: string;

        };
    }
    
    const AanvragerBox = ({ title, project }: AanvragerBoxProps) => {

    return (
      <div className="box">
        <h2>{title}</h2>
        <div className='items'>
          {labelValue(project?.requestorAccount?.name, "Aanvrager")}
          {labelValue(project?.requestorContact?.name, "Contact")}
          {labelValue(project?.requestorAccountType, "Type")}
          {labelValue(project?.requestorSubType, "Subtype")}
          {labelValue(project?.requestorAccountSize, "Grootte")}
        </div>
      </div>
    );
};

export default AanvragerBox;
